import { toast } from "react-toastify";
import { call, put, takeLatest, select } from "redux-saga/effects";
import { updateSOWDetails } from "../http/requests/sow";
import { SOWType, getSOWData, setVtrackLoader } from "../redux/actions";
import { toastOptions } from "../common/utils/toasterOptions";

function* workerUpdateSOWSaga({ payload }) {
  try {
    yield put(setVtrackLoader(true));
    yield call(updateSOWDetails, payload.data);
    const page = payload.data.pageNo ? payload.data.pageNo + 1 : 1;
    const rows = payload.data.rows || 10;
    const clientId = yield select((state) => state.MODULES.sowListClientFilterId);
    toast.success("SOW Updated", toastOptions);
    yield put(
      getSOWData({
        pageNo: page,
        pageSize: rows,
        sortDir: "ASC",
        sortBy: "sowName",
        searchData: "",
        clientId,
      })
    );
    yield put(setVtrackLoader(false));
  } catch (err) {
    toast.error(err?.response?.data?.errorMessage || err?.message || "Failed to update SOW", toastOptions);
    yield put(setVtrackLoader(false));
  }
}

export function* updateSOWSaga() {
  yield takeLatest(SOWType.UPDATE_SOW_DATA, workerUpdateSOWSaga);
}
